import * as React from 'react';
import { Route } from 'react-router';

import NotFound from 'bundles/phoenix/components/NotFound';
import ReviewsApp from 'bundles/reviews/components/ReviewsApp';
import ReviewsPageDirector from 'bundles/reviews/components/ReviewsPageDirector';
import UnifiedUserExperienceHandler from 'bundles/unified-common/providers/UnifiedUserExperienceHandler';

const ReviewsAppWithUserExperienceHandler = (props: React.ComponentProps<typeof ReviewsApp> & object) => (
  <UnifiedUserExperienceHandler>
    <ReviewsApp {...props} />
  </UnifiedUserExperienceHandler>
);

export default (
  <Route path="/" component={ReviewsAppWithUserExperienceHandler}>
    <Route path="learn/:slug/reviews" component={ReviewsPageDirector} />
    <Route path="projects/:slug/reviews" component={ReviewsPageDirector} />
    <Route path="/programs/:programSlug/learn/:slug/reviews" component={ReviewsPageDirector} />
    <Route path="/programs/:programSlug/projects/:slug/reviews" component={ReviewsPageDirector} />
    <Route path="*" component={NotFound} />
  </Route>
);
